import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '../mui/Core/index'

function PageTitle(props) {
  const { title } = props

  const pageTitleStyle = {
    display: 'inline',
    fontSize: '2.625rem',
    color: '#145a4b !important',
    fontFamily: 'SanomatMedium',
    lineHeight: 1.25,
  }

  return <Typography sx={pageTitleStyle}>{title}</Typography>
}

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
}

export default PageTitle
